import { isCustomerDisplayId, parseCustomerDisplayBrand, type CustomerDisplayBrand } from '@washday/utilities';

const key = (displayId: string) => `washday.customerDisplay.brand.${displayId}`;

export function readDisplayBrand(displayId: string): CustomerDisplayBrand | null {
  if (!isCustomerDisplayId(displayId)) return null;
  try { return parseCustomerDisplayBrand(JSON.parse(localStorage.getItem(key(displayId)) || 'null')); }
  catch { return null; }
}

export function saveDisplayBrand(displayId: string, brand: CustomerDisplayBrand) {
  if (!isCustomerDisplayId(displayId)) return;
  const safeBrand = parseCustomerDisplayBrand(brand);
  if (!safeBrand) return;
  try {
    if (safeBrand.name) localStorage.setItem(key(displayId), JSON.stringify(safeBrand));
    else localStorage.removeItem(key(displayId));
  } catch { /* Branding still works when browser storage is unavailable. */ }
}
